import React, { useEffect, useState } from 'react';
import Topbar from '../../admin/layouts/Topbar';
import '../../superadmin/styles/pages/dashboard.css';
import { Typography, Grid, CircularProgress } from '@mui/material';
import anganwadi_icon from '../../superadmin/assets/icons/add-school.svg'
import addanganvadi_icon from '../../superadmin/assets/icons/add-anganwadi-icon.svg';
import totalschools_icon from '../../superadmin/assets/icons/dashboard-school-icon.svg';
import products_icon from '../../superadmin/assets/icons/products_icon.svg';
import totalstudents_icon from '../../superadmin/assets/icons/total-students-icon.svg';
import instance from '../../utils/Api';
import { useNavigate } from "react-router-dom";


const Dashboard = () => {
    const navigate = useNavigate();
    const [adminData, setAdminData] = useState();
    const [studentsCount, setStudentsCount] = useState('');
    const [loading, setLoading] = useState(false);




    const getStudents = async () => {
        try {
            const response = await instance.get(`/api/v1/newrouts/getStudents?count=${true}`);
            setStudentsCount(response.data.data);
        } catch (error) {
            if (error.response && error.response.data) {
                alert(JSON.stringify(error.response.data)); // Display error message
            } else {
                alert('An error occurred'); // Display generic error message
            }
        }
        finally {
            setLoading(false);
        }
    }
    const getAdmin = async () => {
        try {
            const response = await instance.get('/api/v1/newrouts/getAdminbyid');
            setAdminData(response.data.admin);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getStudents();
        getAdmin();
        setLoading(true);
    }, []);

    console.log(adminData);

    return (
        <React.Fragment>
            <Topbar />
            {loading ? (
                <div className="loading">
                    <CircularProgress />
                </div>
            ) : (
                <section className='main-1'>
                    <div className='dashboard-content-text'>
                        <Typography variant='h2'>Welcome to your dashboard, {adminData?.name}</Typography>
                        <Typography variant='h5'>{adminData?.email}</Typography>
                    </div>
                    <section className='dashboard-count'>
                        <Grid container spacing={5}>
                            <Grid item xs={12} sm={6} md={4} lg={4}>
                                <div className='dashboard-box' >
                                    <img src={totalschools_icon} alt='total_schools' />
                                    <Typography>Total Students</Typography>
                                    <Typography variant='h6'>{studentsCount}</Typography>
                                </div>
                            </Grid>

                        </Grid>
                    </section>
                    <section className='admin-section'>

                    </section>
                </section>
            )
            }
        </React.Fragment>
    )
}

export default Dashboard